import React from 'react';
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import styles from "../styles/live-penalties-module.module.scss";
import classNames from "classnames";
import {EntityLogo} from "../../../core/components/logos/entity-logo";

export class LivePenaltiesModuleHeaderTitlesProps extends BaseProps {
}

export const LivePenaltiesModuleHeaderTitles = ({controller}: LivePenaltiesModuleHeaderTitlesProps) => {
  const {state} = controller;
  const {competitorVM, terms, title} = state

  const entityLogoProps = {
    entity: competitorVM,
    width: 48,
    height: 48,
  }
  return (
    <div className={classNames(styles.header_titles_container)}>
      <EntityLogo {...entityLogoProps}/>
      <div className={classNames(styles.header_title_name_container)}>{title}</div>
      <div className={classNames(styles.header_subtitle_container)}>{terms.WEB_PENALTY_POPUP_TOP_PENALTY_KICKERS}</div>
    </div>
  )
}
